// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
export const SALENG_SHOP_API_PROD = "https://api-v2.scrapyard.tjl.co.th";
// export const SALENG_SHOP_API_PROD = "http://localhost:9002";
export const LOCAL_URL = "http://localhost:3001";
// export const LOCAL_URL = "http://192.168.0.242:3001";
